// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-card {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 20px 22px 24px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 22px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.35);
  color: #fff;
  overflow: hidden;
  margin-bottom: 32px;
}
.product-card:last-of-type {
  margin-bottom: 120px;
}

.product-title {
  font-size: clamp(1rem, 4vw, 1.2rem);
  font-weight: 600;
  line-height: 1.25;
  max-height: 2.5em;
  overflow: hidden;
  text-overflow: ellipsis;
}

.product-article {
  font-size: 0.8rem;
  opacity: 0.75;
  margin-top: 2px;
}

.product-info {
  font-size: 0.9rem;
  display: grid;
  row-gap: 6px;
}

.product-amount {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
  margin-top: 16px;
  -webkit-user-select: none;
          user-select: none;
}
.product-amount button {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  font-size: 1.5rem;
  line-height: 48px;
  text-align: center;
  background: #0a66ff;
  color: #fff;
  border: none;
  transition: background 0.2s, transform 0.1s;
}
.product-amount button:active {
  transform: scale(0.92);
}
.product-amount button:hover {
  background: #084cd6;
}
.product-amount span {
  font-size: 1.25rem;
  font-weight: 600;
  min-width: 24px;
  text-align: center;
}

.product-stock {
  display: flex;
  align-items: center;
}

.product-image img {
  width: 100%;
  max-height: 260px;
  object-fit: contain;
  border-radius: 14px;
}

.delete-button {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 1.3rem;
  font-weight: 700;
  background: #ff3b30;
  color: #fff;
  border: none;
  transition: background 0.2s, transform 0.1s;
}
.delete-button:hover {
  background: #d82a1f;
}
.delete-button:active {
  transform: scale(0.9);
}

.out {
  color: #ff6262;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/components/ProductCard/ProductCard.scss"],"names":[],"mappings":"AAUA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;EACA,qCAhBkB;EAiBlB,2CAAA;EACA,mBAAA;EACA,0CAjBkB;EAkBlB,WAbkB;EAclB,gBAAA;EACA,mBAAA;AATF;AAUE;EAAiB,oBAAA;AAPnB;;AAUA;EACE,mCAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;AAPF;;AASA;EAAmB,iBAAA;EAAiB,aAAA;EAAa,eAAA;AAHjD;;AAKA;EAAgB,iBAAA;EAAiB,aAAA;EAAc,YAAA;AAC/C;;AACA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,yBAAA;UAAA,iBAAA;AAEF;AADE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAjDgB;EAkDhB,WAAA;EACA,YAAA;EACA,2CAAA;AAGJ;AAFI;EAAW,sBAAA;AAKf;AAJI;EAAW,mBArDK;AA4DpB;AALE;EAAO,kBAAA;EAAmB,gBAAA;EAAiB,eAAA;EAAgB,kBAAA;AAW7D;;AARA;EACE,aAAA;EACA,mBAAA;AAWF;;AARA;EACE,WAAA;EAAY,iBAAA;EAAkB,mBAAA;EAAoB,mBAAA;AAcpD;;AAXA;EACE,kBAAA;EAAmB,SAAA;EAAU,WAAA;EAC7B,WAAA;EAAY,YAAA;EACZ,aAAA;EAAc,mBAAA;EAAoB,uBAAA;EAClC,kBAAA;EACA,iBAAA;EAAkB,gBAAA;EAClB,mBAxEkB;EAwED,WAAA;EAAY,YAAA;EAC7B,2CAAA;AAsBF;AArBE;EAAW,mBAzEO;AAiGpB;AAvBE;EAAW,qBAAA;AA0Bb;;AAvBA;EAAO,cAAA;EAAe,gBAAA;AA4BtB","sourcesContent":["$bg-card:           rgba(255,255,255,0.05);\n$bg-card-hover:     rgba(255,255,255,0.08);\n$shadow-card:       0 4px 14px rgba(0,0,0,.35);\n$blue:              #0a66ff;\n$blue-dark:         #084cd6;\n$red:               #ff3b30;\n$red-dark:          #d82a1f;\n$text:              #fff;\n\n\n.product-card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  padding: 20px 22px 24px;\n  background: $bg-card;\n  border: 1px solid rgba(255,255,255,0.06);\n  border-radius: 22px;\n  box-shadow: $shadow-card;\n  color: $text;\n  overflow: hidden;\n  margin-bottom: 32px;\n  &:last-of-type { margin-bottom: 120px; }\n}\n\n.product-title {\n  font-size: clamp(1rem, 4vw, 1.2rem);\n  font-weight: 600;\n  line-height: 1.25;\n  max-height: 2.5em;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.product-article { font-size:.8rem; opacity:.75; margin-top:2px; }\n\n.product-info { font-size:.9rem; display:grid; row-gap:6px; }\n\n.product-amount {\n  display:flex;\n  justify-content:center;\n  align-items:center;\n  gap:24px;\n  margin-top:16px;\n  user-select:none;\n  button {\n    width:48px;\n    height:48px;\n    border-radius:12px;\n    font-size:1.5rem;\n    line-height:48px;\n    text-align:center;\n    background:$blue;\n    color:#fff;\n    border:none;\n    transition:background .2s,transform .1s;\n    &:active { transform:scale(.92); }\n    &:hover  { background:$blue-dark; }\n  }\n  span { font-size:1.25rem; font-weight:600; min-width:24px; text-align:center; }\n}\n\n.product-stock {\n  display: flex;\n  align-items: center;\n}\n\n.product-image img {\n  width:100%; max-height:260px; object-fit:contain; border-radius:14px;\n}\n\n.delete-button {\n  position:absolute; top:14px; right:14px;\n  width:40px; height:40px;\n  display:flex; align-items:center; justify-content:center;\n  border-radius:50%;\n  font-size:1.3rem; font-weight:700;\n  background:$red; color:#fff; border:none;\n  transition:background .2s, transform .1s;\n  &:hover  { background:$red-dark; }\n  &:active { transform:scale(.9); }\n}\n\n.out { color:#ff6262; font-weight:600; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
